import Config from "@/config";
import { $catch } from '@/utils';
//判断是否有权限
export const checkAuth = (functionName,type) => {
    if (functionName) {
        let functionsList; //[{menuId:0,btnCode:"add"},{menuId:2,btnCode:"del"}]
        functionsList = $catch.getSessionItem(Config.userRoute)
        if (!functionsList) {
            return false;
        }

        const functions = functionName.split(',');
        let flag
        if(type){
            flag = functions.some((value) =>
                functionsList.menuList.some(v=>v.path == value)
            );
        }else{
            flag = functions.some((value) =>
                functionsList.btnList.includes(value)
            );
        }

        return flag;
    } else {
        return false;
    }
}
